import { render } from "./EmptyChart.vue?vue&type=template&id=a6079944"
import script from "./EmptyChart.vue?vue&type=script&lang=js"
export * from "./EmptyChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__